import type { ComponentOrReferenceFormattingRule } from '@ardoq/data-model';
import { APIEntityType } from '@ardoq/api-types';
import {
  getTypeHeaderLabel,
  useFormattingContext,
  type FormattingContextState,
} from '@ardoq/perspectives';
import { t } from '@ardoq/i18n';
import { FormattingRuleTypePicker } from '@ardoq/perspectives';
import { RowHeader } from '../../../atoms';

type FormattingRuleTypePickerProperties = {
  rule: ComponentOrReferenceFormattingRule;
  formattingContext: FormattingContextState;
};

const SidebarFormattingRuleTypePicker = ({
  rule,
  formattingContext,
}: FormattingRuleTypePickerProperties) => {
  const { i18nLocale } = useFormattingContext();
  const { type } = rule;
  const isComponent = type === APIEntityType.COMPONENT;

  const typeHeaderLabel = getTypeHeaderLabel(i18nLocale, type);

  const typeSelectedAriaLabel = isComponent
    ? t(
        i18nLocale,
        'perspectives:formattingRuleTypePicker.selectedComponentTypeAriaLabel',
        'Selected Component type'
      )
    : t(
        i18nLocale,
        'perspectives:formattingRuleTypePicker.selectedReferenceTypeAriaLabel',
        'Selected Reference type'
      );
  return (
    <>
      <RowHeader>{typeHeaderLabel}</RowHeader>
      <FormattingRuleTypePicker
        rule={rule}
        formattingContext={formattingContext}
        menuPortalTarget={null}
        ariaLabel={typeSelectedAriaLabel}
      />
    </>
  );
};
export { SidebarFormattingRuleTypePicker };
